<template>
  <div>
    <div class="my-3">
      Sign up for daily human curated analytical content.
    </div>
    <LocationsSelector
      :selected-locations="notification.formatted.params.locations"
      :read-only="readOnly"
      @change-locations="handleChangeLocations"
    ></LocationsSelector>
    <v-card flat class="pt-4">
      <v-card-title class="px-0"
        ><legend class="v-label theme--light">Risk types</legend></v-card-title
      >
      <v-card-text class="notification-analysis-risk-container px-0">
        <RiskCategoriesPicker
          v-if="isRiskCategoriesFeatureUnlocked"
          :selected-risk-categories="selectedRiskCategories"
          @change="handleChangeRiskCategories"
        ></RiskCategoriesPicker>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import lodashCloneDeep from "lodash/cloneDeep";
import lodashOrderBy from "lodash/orderBy";
import lodashGet from "lodash/get";

import { MODULE_PREFIX_NOTIFICATIONS } from "@/store";
import { GET_NOTIFICATION } from "@/store/actions.type";
import { mapGetters } from "vuex";

export default {
  name: "NotificationsBriefingsCountryAnalysis",
  components: {
    LocationsSelector: () => import("@/components/common/LocationsSelector"),
    RiskCategoriesPicker: () =>
      import("@/components/riskCategories/RiskCategoriesPicker"),
  },
  props: {
    readOnly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selectedRiskCategories: null,
    };
  },
  computed: {
    ...mapGetters({
      notification: MODULE_PREFIX_NOTIFICATIONS + "notification",
    }),
    isRiskCategoriesFeatureUnlocked() {
      return this.featureUnlocked("alerts-analysis-risk-categories");
    },
  },
  async mounted() {
    if (lodashGet(this.notification, "formatted.params.riskCategories")) {
      this.selectedRiskCategories = this.notification.formatted.params.riskCategories.join();
    }
  },
  methods: {
    handleChangeRiskCategories(params) {
      this.selectedRiskCategories = params.riskCategories;
      const notification = lodashCloneDeep(this.notification);
      notification.formatted = notification.formatted || {};
      notification.formatted.params = notification.formatted.params || {};
      notification.formatted.params.riskCategories = this.selectedRiskCategories.split(
        ","
      );
      this.update(notification);
    },
    handleChangeLocations(locations) {
      const notification = lodashCloneDeep(this.notification);
      notification.formatted = notification.formatted || {};
      notification.formatted.params = notification.formatted.params || {};
      notification.formatted.params.locations = locations;
      this.update(notification);
    },
    update(notification) {
      this.$store.dispatch(
        MODULE_PREFIX_NOTIFICATIONS + GET_NOTIFICATION,
        notification
      );
    },
  },
  watch: {},
};
</script>

<style scoped>
.notification-analysis-risk-container {
  max-height: 370px;
  overflow-y: auto;
  overflow-x: hidden;
}
</style>
